export default {
	SERVICO: { value: 'SERVICO', text: 'Serviço', sigla: 'S' },
	MATERIAL: { value: 'MATERIAL', text: 'Material', sigla: 'M' },
}
